import $ from 'jquery';

export default class {
  constructor(el) {
    this.el = el;
    this.$el = $(this.el);
    this.$select = this.$el.find('select');
    this.placeholder();
    this.bindEvents();
  }
  placeholder() {
    this.$el.each(function() {
      let $input = $(this).find('.input');
      let $select = $(this).find('select');
      if (!$select.val()) {
        $input.text($input.data('placeholder')).addClass('is-empty');
      }
      else {
        $input.text($select.find('option:selected')[0].label).removeClass('is-empty');
      }
      
    });
  }
  bindEvents() {
    this.$select.on('change', this.change.bind(this));
  }
  change(event) {
    let $select = $(event.target);
    let $input = $select.parents(this.el).find('.input');
    let $selected = $select.find('option:selected');
    let text = $selected[0].label;
    let value = $(event.target).val();
    if (value) {
      $input
        .text(text)
        .removeClass('is-empty');
    }
    else {
      $input
        .text($input.data('placeholder'))
        .addClass('is-empty');
    }
    
  }
}

// $('.js-select select').on('change', function () {
//
//
// });



// WEBPACK FOOTER //
// ./modules/select.js